import { useState } from "react";
import {
  EnvelopeFill,
  GeoAltFill,
  TelephoneFill,
  Clipboard,
  CalendarCheck,
  BoxArrowUpRight,
} from "react-bootstrap-icons";
import { Modal, Button } from "react-bootstrap";

const doctors = [
  {
    name: "Dr Benjamin Piper",
    phone: "07929040880",
    email: "benjamin.piper@irise-psychology.london",
  },
  {
    name: "Dr René De Barr",
    phone: "07539447298",
    email: "rene.debarr@irise-psychology.london",
  },
];

const clinikoLink = "https://mentispsychology.cliniko.com/bookings#location";

export default function ContactUs() {
  const [showBookingModal, setShowBookingModal] = useState(false);

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
  };

  const handleCall = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  return (
    <section id="contact" className="py-5 section-tint">
      <div className="py-4 main-wrap">
        <div className="text-center mb-4">
          <h2 className="h1 fw-semibold mb-2">Contact Us</h2>
          <p className="text-secondary mb-0">
            Get in touch with iRise Psychology for appointments or enquiries.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card h-100 shadow-sm border-0 rounded-4">
              <div className="card-body p-4">
                <h3 className="h5 fw-semibold text-center mb-3">
                  iRise Psychology
                </h3>

                <div className="d-flex justify-content-center mb-4">
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill px-4 d-inline-flex align-items-center gap-2"
                    onClick={() => setShowBookingModal(true)}
                  >
                    <CalendarCheck size={18} />
                    Book an appointment
                  </button>
                </div>

                {doctors.map((doctor) => (
                  <div key={doctor.name} className="mb-4">
                    <p className="fw-semibold mb-2 text-center">
                      {doctor.name}
                    </p>

                    <div className="contact-item">
                      <div className="contact-icon">
                        <TelephoneFill size={18} />
                      </div>

                      <div className="flex-grow-1">
                        <p className="mb-1 fw-semibold">Phone</p>
                        <p className="text-secondary mb-0">{doctor.phone}</p>
                      </div>

                      <div className="d-flex gap-2">
                        <TelephoneFill
                          size={20}
                          role="button"
                          onClick={() => handleCall(doctor.phone)}
                        />
                        <Clipboard
                          size={20}
                          role="button"
                          onClick={() => handleCopy(doctor.phone)}
                        />
                      </div>
                    </div>

                    <div className="contact-item">
                      <div className="contact-icon">
                        <EnvelopeFill size={18} />
                      </div>

                      <div className="flex-grow-1">
                        <p className="mb-1 fw-semibold">Email</p>
                        <p className="mb-0">
                          <a
                            href={`mailto:${doctor.email}`}
                            className="text-decoration-none brand-text-light"
                          >
                            {doctor.email}
                          </a>
                        </p>
                      </div>

                      <div className="d-flex gap-2">
                        <Clipboard
                          size={20}
                          role="button"
                          onClick={() => handleCopy(doctor.email)}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <div className="contact-item mb-0">
                  <div className="contact-icon">
                    <GeoAltFill size={18} />
                  </div>
                  <div>
                    <p className="mb-1 fw-semibold">Address</p>
                    <p className="text-secondary mb-0">
                      The Wexner Building
                      <br />
                      Strype Street
                      <br />
                      London, E1 7LF
                    </p>
                  </div>
                </div>

                <Modal
                  show={showBookingModal}
                  onHide={() => setShowBookingModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Book an appointment</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <p className="text-secondary mb-3">
                      You can book an appointment in any of the following ways:
                    </p>

                    <div className="d-flex flex-column gap-3">
                      <div className="p-3 border rounded-3">
                        <p className="fw-semibold mb-2">Online</p>
                        <a
                          href={clinikoLink}
                          target="_blank"
                          rel="noreferrer"
                          className="text-decoration-none d-inline-flex align-items-center gap-2"
                        >
                          Book via Cliniko <BoxArrowUpRight size={16} />
                        </a>
                      </div>

                      <div className="p-3 border rounded-3">
                        <p className="fw-semibold mb-2">Phone</p>
                        <p className="text-secondary mb-2">
                          Call either doctor to arrange an appointment.
                        </p>

                        <div className="d-flex flex-column gap-2">
                          {doctors.map((d) => (
                            <div
                              key={d.phone}
                              className="d-flex align-items-center justify-content-between gap-2"
                            >
                              <div className="small">
                                <span className="fw-semibold">{d.name}:</span>{" "}
                                <span className="text-secondary">{d.phone}</span>
                              </div>

                              <div className="d-flex gap-2">
                                <TelephoneFill
                                  size={18}
                                  role="button"
                                  onClick={() => handleCall(d.phone)}
                                />
                                <Clipboard
                                  size={18}
                                  role="button"
                                  onClick={() => handleCopy(d.phone)}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="p-3 border rounded-3">
                        <p className="fw-semibold mb-2">Email</p>
                        <p className="text-secondary mb-2">
                          Email either doctor and we will get back to you.
                        </p>

                        <div className="d-flex flex-column gap-2">
                          {doctors.map((d) => (
                            <div
                              key={d.email}
                              className="d-flex align-items-center justify-content-between gap-2"
                            >
                              <a
                                href={`mailto:${d.email}`}
                                className="small text-decoration-none"
                              >
                                <span className="fw-semibold">{d.name}:</span>{" "}
                                <span className="brand-text-light">{d.email}</span>
                              </a>

                              <Clipboard
                                size={18}
                                role="button"
                                onClick={() => handleCopy(d.email)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowBookingModal(false)}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
